// extracted by mini-css-extract-plugin
export default {"contentContainer":"ErrorModalContent_contentContainer__XGJEn","buttonContainer":"ErrorModalContent_buttonContainer__V0Oo3"};